export function useScreenSize() {
  const screenWidth = ref(0)
  const screenHeight = ref(0)

  const updateScreenSize = () => {
    if (typeof window !== 'undefined') {
      screenWidth.value = window.innerWidth
      screenHeight.value = window.innerHeight
    }
  }

  onMounted(() => {
    updateScreenSize()
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', updateScreenSize)
    }
  })

  onBeforeUnmount(() => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', updateScreenSize)
    }
  })

  return {
    screenWidth,
    screenHeight,
    updateScreenSize,
  }
}
